export const PROD = 'prod';
export const STAGING = 'staging';
export const QA = 'qa';
export const DEV = 'dev';
